import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isCreatorCount: 0,
    estimatedCost: 0,
    platform: 'instagram',
    instaDeals: false,
    animetaVerified: false,
    creatorType: [],
    mixLoader: false,
    generatedCreatorMixList: {},
    mixLessOrGreater: '',
    isGenre: false,
    isBudget: 0,
    isCreatorSize: false,
    isTargetAudience: false,
    isAllPrefilledChecks: null,
    isErrorMessage: '',
    selectedCreatorToCampaignShorlist: [],
    mixTabs: 'efficient_mix',
    pageMeta: {},
    loaderForButton: false,
    mixIdData: {},
    isSelectAll: false,
    filterMixLoader:false,
}

const creatorMixSlice = createSlice({
    name: 'creatormix',
    initialState,
    reducers: {
        setIsCreatorCount(state, action) {
            state.isCreatorCount = action?.payload
        },
        setIsBudget(state, action) {
            state.isBudget = action?.payload
        },
        setEstimatedCost(state, action) {
            state.estimatedCost = action?.payload
        },
        setCreatorMixPlatform(state, action) {
            state.platform = action?.payload
        },
        setInstaDeals(state, action) {
            state.instaDeals = action?.payload
        },
        setAnimetaVerified(state, action) {
            state.animetaVerified = action?.payload
        },
        setMixLoader(state, action) {
            state.mixLoader = action?.payload
        },
        setGeneratedCreatorMixList(state, action) {
            const { totalPages, page, data, overAllMBPBudget, pagination, mixLessOrGreater, errorMessage, algorithmType } = action.payload;
            state.generatedCreatorMixList = pagination
                ?
                {
                    ...state.generatedCreatorMixList,
                    [algorithmType]: { data: [...state.generatedCreatorMixList?.[algorithmType]?.data, ...data], totalPages, overAllMBPBudget, mixLessOrGreater, page, errorMessage, algorithmType }
                }
                :
                { ...state.generatedCreatorMixList, [algorithmType]: { data, totalPages, overAllMBPBudget, mixLessOrGreater, page, errorMessage, algorithmType } }

        },

        resetGeneratedCreatorMixList(state, action) {
            state.generatedCreatorMixList = action?.payload;
        },

        setIsCreatorGenre(state, actions) {
            state.isGenre = actions?.payload
        },
        setIsCreatorSize(state, actions) {
            state.isCreatorSize = actions?.payload
        },
        setIsTargetAudience(state, actions) {
            state.isTargetAudience = actions?.payload
        },
        setIsAllPrefilled(state, actions) {
            state.isAllPrefilledChecks = actions?.payload
        },
        setErrorMessage(state, action) {
            state.isErrorMessage = action?.payload
        },
        setSelectedCreatorTocampaignShorlist(state, action) {
            state.selectedCreatorToCampaignShorlist = [...state.selectedCreatorToCampaignShorlist, action?.payload]
        },
        setMixTabs(state, action) {
            state.mixTabs = action?.payload
        },
        setLoaderForButton(state, action) {
            state.loaderForButton = action?.payload
        },

        setMixIdData(state, action) {
            const { algorithmType } = action?.payload;
            state.mixIdData = { ...state.mixIdData, [algorithmType]: action?.payload }
        },

        resetMixIdData(state, action) {
            state.mixIdData = action?.payload;
        },

        setIsSelectAll(state, action) {
            state.isSelectAll = action?.payload
        },
        clearCreatorMix() {
            return initialState;
        },
        setFilterMixLoader(state, action){
            state.filterMixLoader = action?.payload
        }
    }
});

export const creatorMixActions = creatorMixSlice.actions;

export default creatorMixSlice;